import React from 'react'
import Autosuggest from 'react-autosuggest'

import { Option, Container } from './styles'

import './index.css'

const AutoCompleteInput = ({
  name,
  type,
  placeholder,
  label,
  error,
  classes,
  value = '',
  onChange,
  onBlur,
  onFocus,
  suggestions,
  disabled,
  id,
  noIconSpace,
  fullBorder,
  ...rest
}) => {
  const inputProps = {
    id,
    placeholder,
    value,
    onChange,
    onFocus,
    onBlur,
    type,
    autoComplete: 'off',
    name,
    disabled,
    className: `autocomplete-input${(noIconSpace &&
      ' autocomplete-input-no-icon') ||
      ''}${(fullBorder && ' autocomplete-input-full-border') || ''}`,
  }

  const onSuggestionsFetchRequested = () => null

  const onSuggestionsClearRequested = () => null

  const getSuggestionValue = suggestion => suggestion.name

  const renderSuggestionsContainer = ({ containerProps, children }) => (
    <Container
      {...containerProps}
      style={{
        overflowY: 'auto',
        maxHeight: '200px',
        position: (fullBorder && 'absolute') || undefined,
        width: (fullBorder && 'calc(100% - 45px)') || undefined,
        zIndex: 1,
      }}
    >
      {children}
    </Container>
  )

  const renderSuggestion = (suggestion, { isHighlighted }) => (
    <Option className={classes} active={isHighlighted}>
      {suggestion.name}
    </Option>
  )

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      renderSuggestionsContainer={renderSuggestionsContainer}
      inputProps={inputProps}
      {...rest}
    />
  )
}

export default AutoCompleteInput
